import * as React from "react";
const SvgRow1 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 125, height: 40, viewBox: "0 0 125 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 124, height: 24, rx: 1.5, fill: "white", stroke: "var(--color-background-dark)" }));
export default SvgRow1;
